const indexedDb = window.indexedDB;

let db;
export const conexionIndexedDb = () => {
  const conexion = indexedDb.open("sanarlabs", 1);

  conexion.onsuccess = () => {
    db = conexion.result;
    // console.log("Base de datos abierta", db);
  };

  conexion.onupgradeneeded = (e) => {
    db = e.target.result;
    // console.log("Base de datos creada", db);
    db.createObjectStore("clientes", { keyPath: "id" });
    db.createObjectStore("proveedores", { keyPath: "id" });
    db.createObjectStore("servicios", { keyPath: "id" });
    db.createObjectStore("inventarioMaterial", { keyPath: "id" });
    db.createObjectStore("inventarioReactivo", { keyPath: "id" });
  };

  conexion.onerror = () => {};
};
export const addIndexedDb = (table, data) => {
  const transaccion = db.transaction([table], "readwrite");
  const coleccionObjetos = transaccion.objectStore(table);
  const conexion = coleccionObjetos.add(data);
};

export const getOneIndexedDb = (id) => {};

export const updateIndexedDb = (id) => {};

export const deleteIndexedDb = (id) => {};

export const getAllIndexedDb = async (table) => {
  const transaccion = db.transaction([table], "readwrite");
  const coleccionObjetos = transaccion.objectStore(table);
  //   const conexion = coleccionObjetos.openCursor();
  const conexion = await coleccionObjetos.getAll();
  let data = [];

  conexion.onsuccess = (e) => {
    const result = e.target.result;
    // console.log(result);
  };

  //   conexion.onsuccess = (e) => {
  //     const cursor = e.target.result;
  //     if (cursor) {
  //       data.push(cursor.value);
  //       cursor.continue();
  //     }
  //   };
  //   conexion.onsuccess = (e) => {
  //     let result = e.target.result;
  //     if (result === null) {
  //       return;
  //     }
  //     data.push(result.value);
  //     result.continue();
  //   };

  //   console.log(data);
  //   return conexion;
};
